import api from "app/api/requests/Gallery";
import getChatToken from "app/api/getChatToken";

export const DELETE_ALBUM = 'DELETE_ALBUM';

export const deleteAlbum = (id: string) => (dispatch: any): any => {
	const token = getChatToken();
	return api.deleteAlbum(id, token)
		.then(() => {
			dispatch({
				type: DELETE_ALBUM, payload: id
			});
		});
}
